import gql from 'graphql-tag';
import { sessionReportCommentFieldsFragment } from './sessionReportCommentFieldsFragment';
import { sessionReportEvaluationFieldsFragment } from './sessionReportEvaluationFieldsFragment';
import { sessionReportScoreFieldsFragment } from './sessionReportScoreFieldsFragment';
import { sessionReportSummaryInfoFieldsFragment } from './sessionReportSummaryInfoFieldsFragment';

export const sessionReportDataFieldsFragment = gql`
  fragment AdminSessionReportDataFields on SessionReportData {
    sessionName
    sessionDatetime
    passPercentage
    totalScore {
      ...AdminSessionReportScoreFields
    }
    passedStatus
    sessionComment
    categoryComments {
      ...AdminSessionReportCommentFields
    }
    evaluations {
      ...AdminSessionReportEvaluationFields
    }
    summaryInfo {
      ...AdminSessionReportSummaryInfoFields
    }
  }

  ${sessionReportScoreFieldsFragment}
  ${sessionReportEvaluationFieldsFragment}
  ${sessionReportSummaryInfoFieldsFragment}
  ${sessionReportCommentFieldsFragment}
`;